import { Card, CardContent } from "../ui/Card"
import one from "../../asset/one.png"
import two from "../../asset/two.png"
import three from "../../asset/three.png"
import four from "../../asset/four.png"
import five from "../../asset/five.png"
import six from "../../asset/six.png"

import orangeone from "../../asset/orangeone.png"
import orangetwo from "../../asset/orangetwo.png"
import orangethree from "../../asset/orangethree.png"
import orangefour from "../../asset/orangefour.png"
import orangefive from "../../asset/orangefive.png"
import orangesix from "../../asset/orangesix.png"

export default function Home4() {
  const leads = [
    {
      img: six,
      hoverImg: orangeone,
      title: "Car Accidents",
      desc: "Leads from victims of passenger vehicle crashes ready to pursue compensation.",
      bottomtxt: "Learn More About Your Rights",
    },
    {
      img: two,
      hoverImg: orangetwo,
      title: "Truck & 18-Wheeler Accidents",
      desc: "High-value big rig and semi-truck accident claims for law firms nationwide.",
      bottomtxt: "Learn More About Your Rights",
    },
    {
      img: three,
      hoverImg: orangethree,
      title: "Motorcycle Accidents",
      desc: "Serious motorcycle crash cases delivered directly to your intake team.",
      bottomtxt: "Learn More About Your Rights",
    },
    {
      img: four,
      hoverImg: orangefour,
      title: "Pedestrian Accidents",
      desc: "Exclusive leads from victims struck by vehicles while walking or cycling.",
      bottomtxt: "Learn More About Your Rights",
    },
    {
      img: five,
      hoverImg: orangefive,
      title: "Rideshare (Uber/Lyft) Accidents",
      desc: "Accident leads involving Uber and Lyft drivers—fast-growing and competitive niche.",
      bottomtxt: "Learn More About Your Rights",
    },
    {
      img: one,
      hoverImg: orangesix,
      title: "Commercial Vehicle Accidents",
      desc: "Bus, van, and fleet vehicle accident claims connected directly to your firm.",
      bottomtxt: "Learn More About Your Rights",
    },
  ]

  const handleMouseEnter = (e) => {
    const card = e.currentTarget;
    const baseImg = card.querySelector('.base-img');
    const hoverImg = card.querySelector('.hover-img');
    const bottomText = card.querySelector('.bottom-text');
    
    // Change border color
    card.style.borderColor = '#FC821F';
    
    // Swap images
    if (baseImg) baseImg.style.opacity = '0';
    if (hoverImg) hoverImg.style.opacity = '1';
    
    // Change text color
    if (bottomText) bottomText.style.color = '#FC821F';
  };

  const handleMouseLeave = (e) => {
    const card = e.currentTarget;
    const baseImg = card.querySelector('.base-img');
    const hoverImg = card.querySelector('.hover-img');
    const bottomText = card.querySelector('.bottom-text');
    
    // Reset border color
    card.style.borderColor = '#d1d5db'; // gray-300
    
    // Swap images back
    if (baseImg) baseImg.style.opacity = '1';
    if (hoverImg) hoverImg.style.opacity = '0';
    
    // Reset text color
    if (bottomText) bottomText.style.color = 'white';
  };

  return (
    <div className="min-h-screen bg-[#0A476C] text-white">
      <div className="container mx-auto px-4 py-12 max-w-6xl">
        <div className="text-center mb-12">
          <h1
            className="text-[60px] font-bold mb-6 leading-[80px] text-white"
            style={{ fontFamily: "Futura Bold, sans-serif", fontWeight: 700 }}
          >
            Leads We Generate for Your Firm<br />
          </h1>
          <p
            className="text-[21px] text-white max-w-2xl mx-auto leading-relaxed"
            style={{ fontFamily: "Avenir Book, sans-serif" }}
          >
            No matter your practice focus, we deliver exclusive accident leads tailored to your firm's goals.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {leads.map((lead, index) => (
            <Card
              key={index}
              className="bg-[#0A476C] rounded-lg border-2 border-gray-300 text-white h-full shadow-lg cursor-pointer"
              style={{ transition: 'border-color 0.3s ease' }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <CardContent className="p-6 flex flex-col h-full">
                <div className="w-16 h-16 rounded-full flex items-center justify-center mb-4 mx-auto relative">
                  {/* Base Image */}
                  <img
                    src={lead.img}
                    alt={lead.title}
                    className="base-img w-full h-full object-contain absolute inset-0"
                    style={{ transition: 'opacity 0.3s ease', opacity: 1 }}
                  />
                  {/* Hover Image */}
                  <img
                    src={lead.hoverImg}
                    alt={lead.title}
                    className="hover-img w-full h-full object-contain absolute inset-0"
                    style={{ transition: 'opacity 0.3s ease', opacity: 0 }}
                  />
                </div>

                <h3 className="text-xl font-bold text-center mb-4 text-white">
                  {lead.title}
                </h3>
                <p className="text-sm text-white text-center mb-6 flex-grow">
                  {lead.desc}
                </p>
                <p 
                  className="bottom-text text-sm text-center"
                  style={{ transition: 'color 0.3s ease', color: 'white' }}
                >
                  {lead.bottomtxt}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}